module.exports = __webpack_public_path__ + "media/images/lb/294-f45cc5d9bf58dd148cd971faac6dedb5.svg";